<header>
  <termo-refresh-button
    [refreshing]="refreshing()"
    [progress]="refreshProgress()"
    (refresh)="refresh()"
  >Odśwież</termo-refresh-button>
</header>
